// extracted by mini-css-extract-plugin
export default {"toast":"style_toast__p53xU","toastText":"style_toastText__KXkqf"};